import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "@/components/layout/header";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import AppSidebar from "./app-sidebar";
import { GlobalModal } from "../modal/global-modal";
import { Toaster } from "../ui/sonner";
import { GlobalLoadingSpinner } from "../modal/global-loading-spinner";
import { useI18n } from "@/contexts/I18nContext";

export default function Layout() {
  const { t } = useI18n();
  const [defaultOpen, setDefaultOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getSidebarState = async () => {
      try {
        const sidebarStateValue = await cookieStore.get("sidebar_state");

        if (sidebarStateValue === null) {
          setDefaultOpen(true);
        } else {
          const isOpen = sidebarStateValue?.value === "true";
          setDefaultOpen(isOpen);
        }
      } catch (error) {
        console.error("쿠키 읽기 실패:", error);
        setDefaultOpen(true);
      } finally {
        setIsLoading(false);
      }
    };

    getSidebarState();
  }, []);

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div>{t("common.loading")}</div>
      </div>
    );
  }

  return (
    <div className="h-screen overflow-hidden [--header-height:calc(--spacing(14))]">
      <Toaster />
      <GlobalModal />
      <GlobalLoadingSpinner />
      <SidebarProvider className="flex flex-col" defaultOpen={defaultOpen}>
        <Header />
        <div className="flex min-h-0 min-w-0 flex-1 overflow-hidden">
          <AppSidebar />
          <SidebarInset className="min-h-0 min-w-0 overflow-hidden">
            <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-hidden">
              <Outlet />
            </div>
          </SidebarInset>
        </div>
      </SidebarProvider>
    </div>
  );
}
